import React, { useState, useEffect } from 'react';
import styled, { keyframes, css } from 'styled-components';
import logo from '../pages/images/logo.svg'; // ロゴのパスを正しく指定してください

// ロゴのフェードアウトアニメーション
const fadeOutLogo = keyframes`
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
`;

// 背景が左から右に広がるアニメーション
const splashExpand = keyframes`
  0% {
    transform: scaleX(0);
    transform-origin: left;
  }
  50% {
    transform: scaleX(1);
    transform-origin: left;
  }
  50.001% {
    transform-origin: right;
  }
  100% {
    transform: scaleX(0);
    transform-origin: right;
  }
`;

// スプラッシュ画面のコンテナ
const SplashScreenContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  background: #fafafa;
  overflow: hidden; /* 背景のアニメーションを隠す */

  ${({ $isFadingOut }) =>
    $isFadingOut &&
    css`
      background-color: #007c3f;
      animation: ${splashExpand} 0.8s forwards;
    `}
`;

// ロゴのスタイリング
const SplashLogo = styled.img`
  width: 200px;
  height: auto;

  ${({ $isFadingOut }) =>
    $isFadingOut &&
    css`
      animation: ${fadeOutLogo} 1s forwards;
    `}
`;

const SplashScreen = () => {
  const [isVisible, setIsVisible] = useState(true);
  const [isLogoFadingOut, setIsLogoFadingOut] = useState(false);
  const [isBackgroundFadingOut, setIsBackgroundFadingOut] = useState(false);

  useEffect(() => {
    // 1秒後にロゴをフェードアウト開始
    const logoTimer = setTimeout(() => {
      setIsLogoFadingOut(true);
    }, 1000);

    // ロゴが消えた後、0.8秒後に背景の色を変更しながらフェードアウト
    const backgroundTimer = setTimeout(() => {
      setIsBackgroundFadingOut(true);
    }, 1800);

    // スプラッシュ画面を非表示に
    const hideSplashScreen = setTimeout(() => {
      setIsVisible(false);
    }, 2600);

    return () => {
      clearTimeout(logoTimer);
      clearTimeout(backgroundTimer);
      clearTimeout(hideSplashScreen);
    };
  }, []);

  if (!isVisible) return null;

  return (
    <SplashScreenContainer $isFadingOut={isBackgroundFadingOut}>
      <SplashLogo src={logo} alt="AGRIST Logo" $isFadingOut={isLogoFadingOut} />
    </SplashScreenContainer>
  );
};

export default SplashScreen;
